import React, { useState, useEffect } from "react";
import "./NoInternetScreen.css";

function NoInternetScreen({ onRetry }) {
  const [checking, setChecking] = useState(false);

  const handleRetry = async () => {
    setChecking(true);
    await new Promise((r) => setTimeout(r, 800));
    if (typeof onRetry === "function") onRetry();
    setChecking(false);
  };

  return (
    <div className="no-internet-screen" dir="rtl">
      <div className="no-internet-content">
        <div className="no-internet-icon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="1" y1="1" x2="23" y2="23" />
            <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
            <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
            <path d="M10.71 5.05A16 16 0 0 1 22.56 9" />
            <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
            <line x1="12" y1="20" x2="12.01" y2="20" />
          </svg>
        </div>

        <h2 className="no-internet-title">لا يوجد اتصال بالإنترنت</h2>
        <p className="no-internet-message">
          تعذّر الاتصال بالخادم. يرجى التحقق من اتصالك بالإنترنت والمحاولة مجدداً.
        </p>

        <button
          className="no-internet-retry-btn"
          onClick={handleRetry}
          disabled={checking}
        >
          {checking ? (
            <span className="no-internet-spinner" />
          ) : (
            "إعادة المحاولة"
          )}
        </button>
      </div>
    </div>
  );
}

export default NoInternetScreen;
